import { InformationSlabCircleIcon } from './InformationSlabCircleIcon';

/**
 * author: Jeff Anders
 * id 7AF3BC52-D506-4CCB-A813-A7785CFD6524
 * name information-slab-circle
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-circle.svg
 * tags
 * - Settings 
 */
export const InfoSlabCircleIcon = InformationSlabCircleIcon;
export default InfoSlabCircleIcon